import { useTsRest } from '@/_shared/context/ts-rest.js';
import { useToast } from '@/_shared/hooks/toast.js';
import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    Spinner,
} from '@fluentui/react-components';
import { useNavigate } from '@tanstack/react-router';
import { trackException } from '@this/app-shared/dist/tools/insights/track.js';
import { useCallback, useState } from 'react';
import { useStyles } from './styles.js';

export function NewClaimCreate() {
    const styles = useStyles();
    const navigate = useNavigate();
    const tsr = useTsRest();
    const [isDialogOpen, setIsDialogOpen] = useState(true);
    const [isCreating, setIsCreating] = useState(false);
    const toast = useToast();

    const { mutateAsync: createNewClaim } = tsr.newClaim.createNewClaim.useMutation();

    const handleYes = useCallback(async () => {
        try {
            setIsDialogOpen(false);
            setIsCreating(true);
            const result = await createNewClaim({ body: {} });
            if (result.status !== 200) {
                throw new Error('Failed to create new claim');
            }
            navigate({ to: '/new-claim/$id', params: { id: result.body.id }, replace: true });
            toast('Schaden erstellt', 'Der Schaden wurde erfolgreich erstellt.', { intent: 'success', timeout: 3000 });
        } catch (error) {
            toast('Fehler', 'Der Schaden konnte nicht erstellt werden.', { intent: 'error', timeout: 3000 });
            trackException(error);
        } finally {
            setIsCreating(false);
        }
    }, [createNewClaim, navigate, toast]);

    const handleNo = useCallback(() => {
        setIsDialogOpen(false);
        navigate({ to: '/pending-claims', replace: true });
    }, [navigate]);

    return (
        <div className={styles.page}>
            <Dialog open={isDialogOpen}>
                <DialogSurface backdrop={{ className: styles.dialogBackdrop }}>
                    <DialogBody>
                        <DialogTitle>Neuer Schaden</DialogTitle>
                        <DialogContent>Möchten Sie einen neuen Schaden anlegen?</DialogContent>
                        <DialogActions>
                            <Button appearance="secondary" onClick={handleNo}>
                                Nein
                            </Button>
                            <Button appearance="primary" onClick={handleYes}>
                                Ja
                            </Button>
                        </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
            {isCreating && <Spinner size="large" label="Erstelle neuen Schaden..." />}
        </div>
    );
}
